import React from 'react'

import { ClinTheme } from '../../../ClinTheme'
import { ClinText } from '../../../components/ClinText'
import {
  PatientOrderStatus,
  mapToPatientOrderStatus,
  resolvePatientOrderStatusLabel
} from '../../../pages/Patients/PatientDashboard/Patient.model'
import { StyledStatusWrapper } from '../../Patients/PatientDashboard/PatientDashboard.styles'

interface PatientDetailsStatusCardProps {
  status: PatientOrderStatus | string | undefined
}

const PatientDetailsStatusCard: React.FC<PatientDetailsStatusCardProps> = ({
  status
}) => {
  if (!status) {
    return null
  }

  const { backgroundColor, textColor } = getStatusColor(
    mapToPatientOrderStatus(status) as PatientOrderStatus
  )

  return (
    <StyledStatusWrapper color={backgroundColor}>
      <ClinText
        fontWeight={ClinTheme.fontWeights.medium}
        color={textColor}
        fontSize={ClinTheme.fontSizes[0]}
        textAlign="center"
        lineHeight={'2'}
      >
        {resolvePatientOrderStatusLabel(status)}
      </ClinText>
    </StyledStatusWrapper>
  )
}

const getStatusColor = (status: PatientOrderStatus | string | undefined) => {
  switch (status) {
    case PatientOrderStatus.Active:
      return {
        backgroundColor: 'rgba(0, 162, 35, 0.1)',
        textColor: ClinTheme.colors.greenValid
      }
    case PatientOrderStatus.PatientDiscontinued:
    case PatientOrderStatus.ProgramClosed:
      return {
        backgroundColor: 'rgba(117, 117, 117, 0.1)',
        textColor: ClinTheme.colors.darkGrey
      }
    case PatientOrderStatus.BeginOrder:
    case PatientOrderStatus.IncompletePAF:
    case PatientOrderStatus.IncompleteCheckout:
    case PatientOrderStatus.ReadyForResupply:
      return {
        backgroundColor: 'rgba(0, 67, 206, 0.1)',
        textColor: ClinTheme.colors.tealishBlue
      }
    case PatientOrderStatus.Processing:
    case PatientOrderStatus.InTransit:
    case PatientOrderStatus.OutForDelivery:
    case PatientOrderStatus.Available_for_Pickup:
    case PatientOrderStatus.FailedAttempt:
    case PatientOrderStatus.Delivered:
    case PatientOrderStatus.Pending:
    case PatientOrderStatus.Shipped:
    case PatientOrderStatus.Submitted:
      return {
        backgroundColor: 'rgba(0, 162, 35, 0.1)',
        textColor: ClinTheme.colors.greenValid
      }
    case PatientOrderStatus.UnderMedicalReview:
    case PatientOrderStatus.FailedDelivery:
    case PatientOrderStatus.HealthAuthorityReview:
    case PatientOrderStatus.UnderReview:
    case PatientOrderStatus.AwaitingConsent: // CLOS-13409 / CLOS-13741: Figma 8599:2612
      return {
        backgroundColor: ClinTheme.colors.ptaConsentStatusBackground,
        textColor: ClinTheme.colors.orangeWarn
      }
    case PatientOrderStatus.AwaitingBaselineData:
      return {
        backgroundColor: ClinTheme.colors.ptaConsentStatusBackground,
        textColor: ClinTheme.colors.tealishBlue
      }
    default:
      return {
        backgroundColor: 'rgba(117, 117, 117, 0.1)',
        textColor: ClinTheme.colors.darkGrey
      }
  }
}

export default PatientDetailsStatusCard
